import React, { useState, useEffect } from "react";
import axios from "axios";
import "./App.css";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [properties, setProperties] = useState([]);
  const [selectedProperty, setSelectedProperty] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [analyticsData, setAnalyticsData] = useState(null);
  const [searchConsoleData, setSearchConsoleData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const sessionId = urlParams.get("session_id");

    if (sessionId) {
      localStorage.setItem("sessionId", sessionId);
      setIsAuthenticated(true);
      setUser({ name: "Google User" });
      fetchProperties(sessionId);
      window.history.replaceState({}, document.title, window.location.pathname);
    } else {
      const savedSessionId = localStorage.getItem("sessionId");
      if (savedSessionId) {
        setIsAuthenticated(true);
        setUser({ name: "Google User" });
        fetchProperties(savedSessionId);
      }
    }
  }, []);

  const fetchProperties = async (sessionId) => {
    try {
      const response = await axios.post("https://fesnexies.stage3.demo321.com/api/properties", {
        sessionId,
      });
      setProperties(response.data);
    } catch (error) {
      console.error("Error fetching properties:", error);
      setProperties([]);
    }
  };

  const fetchAnalyticsData = async () => {
    setLoading(true);
    try {
      const sessionId = localStorage.getItem("sessionId");
      const response = await axios.post("https://fesnexies.stage3.demo321.com/api/analytics-data", {
        sessionId,
        propertyId: selectedProperty,
      });
      setAnalyticsData(response.data);
    } catch (error) {
      console.error("Error fetching analytics data:", error);
    }
    setLoading(false);
  };

  const fetchSearchConsoleData = async () => {
    setLoading(true);
    try {
      const sessionId = localStorage.getItem("sessionId");
      const response = await axios.post("https://fesnexies.stage3.demo321.com/api/search-console", {
        sessionId,
        siteUrl: selectedProperty,
      });
      setSearchConsoleData(response.data);
    } catch (error) {
      console.error("Error fetching search console data:", error);
    }
    setLoading(false);
  };

  const handleLogin = async () => {
    try {
      const response = await axios.get("https://fesnexies.stage3.demo321.com/auth/url");
      window.location.href = response.data.authUrl;
    } catch (error) {
      console.error("Login error:", error);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("sessionId");
    setIsAuthenticated(false);
    setUser(null);
    setProperties([]);
    setAnalyticsData(null);
    setSearchConsoleData(null);
  };

  if (!isAuthenticated) {
    return (
      <div className="container">
        <div className="login-card">
          <h1>Google Analytics Dashboard</h1>
          <p>Sign in with Google to access your analytics data</p>
          <button className="login-btn" onClick={handleLogin}>
            Sign in with Google
          </button>
        </div>
      </div>
    );
  }

  return (
    <div>
      <header className="header">
        <h1>Analytics Dashboard</h1>
        <div className="user-info">
          <span>Hello, {user?.name}</span>
          <button className="logout-btn" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </header>

      <div className="main-container">
        <div className="section">
          <h2>Select a Property</h2>
          <select
            value={selectedProperty}
            onChange={(e) => {
              const property = properties.find((p) => p.id === e.target.value);
              setSelectedProperty(property.id);
              setSelectedType(property.type);
            }}
            className="property-select"
          >
            <option value="">Select a property</option>
            {properties.map((property) => (
              <option key={property.id} value={property.id}>
                {property.accountName} → {property.name} ({property.type})
              </option>
            ))}
          </select>
        </div>

        <div className="button-group">
          {selectedType === "GA4" && (
            <button
              className="data-btn"
              onClick={fetchAnalyticsData}
              disabled={!selectedProperty || loading}
            >
              {loading ? "Loading..." : "Fetch Analytics Data"}
            </button>
          )}
          {selectedType === "SC" && (
            <button
              className="data-btn"
              onClick={fetchSearchConsoleData}
              disabled={!selectedProperty || loading}
            >
              {loading ? "Loading..." : "Fetch Search Console Data"}
            </button>
          )}
        </div>

        <div className="data-container">
          {analyticsData && (
            <div className="data-section">
              <h3>📊 Analytics Data (Last 30 Days)</h3>
              <div className="data-list">
                {analyticsData.rows?.map((row, i) => (
                  <div key={i} className="data-item">
                    <h4>{row.dimensionValues[0].value}</h4>
                    <p>
                      👥 Users: {row.metricValues[0].value} | 👀 Views:{" "}
                      {row.metricValues[1].value}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          )}

          {searchConsoleData && (
            <div className="data-section">
              <h3>🔍 Search Console Data (Last 30 Days)</h3>
              <div className="data-list">
                {searchConsoleData.rows?.map((row, i) => (
                  <div key={i} className="data-item">
                    <h4>{row.keys[0]}</h4>
                    <p>
                      🖱️ Clicks: {row.clicks} | 👁️ Impressions:{" "}
                      {row.impressions}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default App;
